import React from 'react'
import { createPortal } from 'react-dom'
import enamelTooth from '@assets/images/enamel-tooth.png'
import type { ScreenLoaderProps } from './ScreenLoader.types'
import { SCREEN_LOADER_SIZE_REMS } from './ScreenLoader.types'
import './ScreenLoader.css'

const ScreenLoader: React.FC<ScreenLoaderProps> = ({
  open = true,
  container,
  size = 'md',
  height,
  inline = false,
  portal = !inline,
  className = '',
  style,
  'aria-label': ariaLabel = 'Loading',
}) => {
  if (!open) {
    return null
  }

  const markRems = height ?? SCREEN_LOADER_SIZE_REMS[size]
  const classNames = [
    'ds-screen-loader',
    inline ? 'ds-screen-loader--inline' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ')

  const content = (
    <div
      className={classNames}
      style={
        {
          ...style,
          ['--ds-screen-loader-size' as string]: `${markRems}rem`,
        } as React.CSSProperties
      }
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={ariaLabel}
    >
      <img
        className="ds-screen-loader__mark"
        src={enamelTooth}
        alt=""
        aria-hidden="true"
        width={96}
        height={96}
      />
    </div>
  )

  if (inline || !portal || typeof document === 'undefined') {
    return content
  }

  const target = container ?? document.body
  return createPortal(content, target)
}

export default ScreenLoader
